import { render, staticRenderFns } from "./StatisticsTradeTurnoverP2PFilters.vue?vue&type=template&id=48668773&scoped=true&"
import script from "./StatisticsTradeTurnoverP2PFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTurnoverP2PFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTurnoverP2PFilters.vue?vue&type=style&index=0&id=48668773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48668773",
  null
  
)

export default component.exports